import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TUser } from '../../store/types';

export const convertUsersToTable = (users: TUser[]): TUser[] => {
  const modifiedUsers: TUser[] = users.map((user) => ({
    ...user,
    created: dayjsCustom(user.created).format('DD.MM.YYYY / HH:mm'),
  }));

  return modifiedUsers;
};
